import { BackendEndpoints } from "../config/backend-endpoints.model";

export type EnvironmentRegionKey = string;

export const API_ENDPOINTS: Record<EnvironmentRegionKey, BackendEndpoints> = {
    'local-scania': {
        apiUrl: 'http://localhost:7001/',
        hubUrl: 'http://localhost:7001/hub/',
        newUiUrl: 'http://localhost:4201/',
    },

    'dev-scania': {
        apiUrl: 'https://api.dcode.devtest.aws.scania.com/',
        hubUrl: 'https://api.dcode.devtest.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode.devtest.aws.scania.com/',
    },
    'preprod-scania': {
        apiUrl: 'https://api.dcode.preprod.aws.scania.com/',
        hubUrl: 'https://api.dcode.preprod.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode.preprod.aws.scania.com/',
    },
    'prod-scania': {
        apiUrl: 'https://api.dcode.prod.aws.scania.com/',
        hubUrl: 'https://api.dcode.prod.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode.prod.aws.scania.com/',
    },

    'local-scaniacn': {
        apiUrl: 'http://localhost:7001/',
        hubUrl: 'http://localhost:7001/hub/',
        newUiUrl: 'https://next.dcode.devtest.aws.scania.com/',
    },
    'dev-scaniacn': {
        apiUrl: 'https://api.dcode.devtest.aws.scania.com/',
        hubUrl: 'https://api.dcode.devtest.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode.devtest.aws.scania.com/',
    },
    'preprod-scaniacn': {
        apiUrl: 'https://api.dcode.devtest.aws.scania.com/',
        hubUrl: 'https://api.dcode.devtest.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode.devtest.aws.scania.com/',
    },
    'prod-scaniacn': {
        apiUrl: 'https://api.dcode.devtest.aws.scania.com/',
        hubUrl: 'https://api.dcode.devtest.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode.devtest.aws.scania.com/',
    },

    'local-international': {
        apiUrl: 'http://localhost:7001/',
        hubUrl: 'http://localhost:7001/hub/',
        newUiUrl: 'https://next.dcode.devtest.aws.scania.com/',
    },
    'dev-international': {
        apiUrl: 'https://api.dcode-us.devtest.gf.aws.scania.com/',
        hubUrl: 'https://api.dcode-us.devtest.gf.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode-us.devtest.gf.aws.scania.com/',
    },
    'us-dev-international': {
        apiUrl: 'https://api.dcode-us.devtest.gf.aws.scania.com/',
        hubUrl: 'https://api.dcode-us.devtest.gf.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode-us.devtest.gf.aws.scania.com/',
    },
    'preprod-international': {
        apiUrl: 'https://api.dcode-us.prod.gf.aws.scania.com/',
        hubUrl: 'https://api.dcode-us.prod.gf.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode-us.prod.gf.aws.scania.com/',
    },
    'prod-international': {
        apiUrl: 'https://api.dcode-us.prod.gf.aws.scania.com/',
        hubUrl: 'https://api.dcode-us.prod.gf.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode-us.prod.gf.aws.scania.com/',
    },
    'us-prod-international': {
        apiUrl: 'https://api.dcode-us.prod.gf.aws.scania.com/',
        hubUrl: 'https://api.dcode-us.prod.gf.aws.scania.com/hub/',
        newUiUrl: 'https://next.dcode-us.prod.gf.aws.scania.com/',
    }
};
